import React from 'react'
import Skeleton from 'react-loading-skeleton'

import useStyles from './styles'

const MediaSkeleton = () => {
  const classes = useStyles()

  return (
    <div className={classes.skeleton}>
      <Skeleton />
    </div>
  )
}

export default MediaSkeleton
